import type { LeadsView } from '@/core/components/leads/leads-list-filter-url';

const LEADS_VIEW_STORAGE_KEY = 'up2promo.leads.view';

/** Last list/board choice on this device (DEV-567); storage may be blocked. */
export function readLeadsViewPreference(): LeadsView | null {
  try {
    const raw = window.localStorage.getItem(LEADS_VIEW_STORAGE_KEY);
    return raw === 'boards' || raw === 'list' ? raw : null;
  } catch {
    return null;
  }
}

export function writeLeadsViewPreference(view: LeadsView): void {
  try {
    window.localStorage.setItem(LEADS_VIEW_STORAGE_KEY, view);
  } catch {
    // Private mode / blocked storage: the URL still carries the view.
  }
}
